import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-client';
import type { ComplianceData, ComplianceFramework } from '@/lib/types';

const FIVE_MINUTES = 1000 * 60 * 5;

export function useComplianceData() {
  return useQuery({
    queryKey: queryKeys.compliance.data(),
    queryFn: async (): Promise<ComplianceData> => {
      const response = await apiClient.get<ComplianceData>('/api/v1/compliance/');
      return response.data;
    },
    refetchInterval: FIVE_MINUTES,
    staleTime: FIVE_MINUTES,
  });
}

export function useComplianceFrameworks() {
  return useQuery({
    queryKey: [...queryKeys.compliance.all, 'frameworks'] as const,
    queryFn: async (): Promise<ComplianceFramework[]> => {
      const response = await apiClient.get<ComplianceFramework[]>(
        '/api/v1/compliance/frameworks/'
      );
      return response.data;
    },
    staleTime: FIVE_MINUTES,
  });
}

export function useExportComplianceReport() {
  const exportReport = async (): Promise<Blob> => {
    const response = await apiClient.get('/api/v1/export/compliance.csv/', {
      responseType: 'blob',
      headers: {
        Accept: 'text/csv',
      },
    });
    return response.data;
  };

  return { exportReport };
}
